import React, {Fragment, useState} from 'react';
import Head from 'next/head';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import useSWR from 'swr';
import Config from '../../config'
import { GetJobList } from '../../api/careers';
import {getStaticPath} from '../../utils'
import PlainBanner from '../../components/common/PlainBanner';
import featureStyles from '../../styles/modules/common/features.module.scss';
import { trackPage } from '../../tracking';
import { getPageViewData } from '../../utils/tracking';
import styles from '../../styles/pages/about-us.module.scss';
import Section from '../../components/common/Section';

const LazyLoader = dynamic(()=> import("@/hoc/LazyLoader"),
  { loading: () => <p>Loading ...</p>,ssr:true }
);

const CareersContactBanner = dynamic(()=> import("../../components/careers/CareersContactBanner"),
  { loading: () => <p>Loading ...</p>,ssr:true }
);
const CultureTwoRowComponent = dynamic(()=> import("../../components/careers/CultureTwoRowComponent"),
  { loading: () => <p>Loading ...</p>,ssr:true }
);
const LifeAtOnsitego = dynamic(()=> import("../../components/careers/LifeAtOnsitego"),
  { loading: () => <p>Loading ...</p>,ssr:true }
);
export async function getServerSideProps(ctx:any) {
    return {
        props: {
            pageName: 'careers',
            nonce: ctx.req.headers?.['x-nonce']
        },
    };
}

const JobListFetcher = async () => {
    const job_list:any  = await GetJobList();
    return job_list ? job_list.data : [];
}

export default function CareerPage(props:any){
    const router  = useRouter()
    const BASE_URL = Config.BASE_URL
    const OG_IMAGE = getStaticPath("/static/images/why-onsitego.svg")

    const {data:job_list} = useSWR("job_list",JobListFetcher,{
        revalidateOnFocus:false
    });

    const CULTURE_ONSITEGO = {
        'points': [
                {
                    'featureTitle': 'Your Growth',
                    'featureText': 'If you’ve got the potential, we’ll provide all the training and support that you need to enhance your career.',
                    'featureImage': '/static/images/careers/culture_feature_list/your-growth.png',
                },
                {
                    'featureTitle': 'Your Job',
                    'featureText': 'With us, you’ll always get a chance to learn more. You’ll have a real job from day one – making decisions, solving problems and working as part of a team.',
                    'featureImage': '/static/images/careers/culture_feature_list/your-job.png',
                },
                {
                    'featureTitle': 'Your Training',
                    'featureText': 'Our learning sessions here will ensure that you are best at what you do, not just at Onsitego but wherever you are!',
                    'featureImage': '/static/images/careers/culture_feature_list/your-training.png',
                },
                {
                    'featureTitle': 'Your Personal Development',
                    'featureText': 'You not only get to live your passion of being a leader in what you do but also a chance to be part of the overall proﬁtable growth of Onsitego throughout your journey with us.',
                    'featureImage': '/static/images/careers/culture_feature_list/your-personal-development.png',
                },
                {
                    'featureTitle': 'Your Performance',
                    'featureText': 'We are not just obsessed about our customers but also about highly passionate people. It’s not us but YOU, who decides your performance development at Onsitego.',
                    'featureImage': '/static/images/careers/culture_feature_list/your-performance.png',
                },
                {
                    'featureTitle': 'Your Space To Be Yourself',
                    'featureText': 'Here, you’ll get to experience a warm and friendly environment, where differences are valued and Onsitegoer’s are encouraged to make decisions independently.',
                    'featureImage': '/static/images/careers/culture_feature_list/your-space-to-be-yourself.png',
                }
        ]
    }

    React.useEffect(()=>{
        trackPage('Careers',{...getPageViewData()})
    },[])

    return (
        <Fragment>
            <Head>
            <title>Careers Opportunity - Job Openings at Onsitego</title>
            <link rel="icon" href="/favicon.ico" />
            <meta name="description" content={"View and apply for current job openings at the Onsitego."}></meta>
            <meta property="og:title" content={"Careers Opportunity - Job Openings at Onsitego"}/>
            <meta property="og:description" content={"View and apply for current job openings at the Onsitego."}/>
            <meta property="og:url" content={`${BASE_URL}${router.asPath}`}/>
            <meta property="og:image" content={OG_IMAGE}/>
            <link rel="canonical" href={`${BASE_URL}${router.asPath}`}></link>
            </Head>

            {/* script tags for integration of keka job listing */}
            <script nonce={props.nonce} dangerouslySetInnerHTML={{ __html: 
                `window.khConfig = { identifier: "69a3b8ae-652d-4847-bc71-23581d950bf8", domain: "https://onsitego.keka.com/careers/", targetContainer: "#khembedjobs"}` }} 
            />
            <script nonce={props.nonce} src='https://onsitego.keka.com/careers/api/embedjobs/js/69a3b8ae-652d-4847-bc71-23581d950bf8' defer/>
         
            <PlainBanner className="contact-us" title="Current Openings at Onsitego - Apply Now" subtitle="" />
            <main>
                <LifeAtOnsitego/>
                {CULTURE_ONSITEGO.points  && <CultureTwoRowComponent withSubtitle={true} features={CULTURE_ONSITEGO.points && CULTURE_ONSITEGO.points} className={`${featureStyles.grey__neutral}`} title={'Culture @Onsitego'} isGreyBackground={true} />}
                <Section className={styles.careers} hasPadding={true} title="Openings @Onsitego" tagline=" If you think, you can help make a difference in our customer’s lives, you can search for opportunities by job title or location." id="job-listing">
                    <div id='khembedjobs' className='container'>
                        <div className={`kh-main-container ${styles.jos_main_container}`}>
                            <div id="kh-embed-jobs-filters"></div>
                            <div id='kh-job-widget'></div>
                        </div>
                    </div>
                </Section>
                <CareersContactBanner/>
            </main>
   
        </Fragment>
    )
}
